<p>help-google-campaign-manager-identity works!</p>
